import { render, staticRenderFns } from "./LoyaltyDeliverance.vue?vue&type=template&id=528ad675&scoped=true&lang=pug&"
import script from "./LoyaltyDeliverance.vue?vue&type=script&lang=js&"
export * from "./LoyaltyDeliverance.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyDeliverance.vue?vue&type=style&index=0&id=528ad675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ad675",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VCard,VDivider,VSimpleTable,VSkeletonLoader})
